import { type FC } from 'react';

import { CustomSkeleton } from 'src/components/CustomSkeleton';

import styles from './styles.module.scss';

interface Props {
  rows?: number;
}

const DEFAULT_ROWS = 10;

export const TalkingPointItemSkeleton: FC<Props> = ({ rows = DEFAULT_ROWS }) =>
  Array.from({ length: rows || DEFAULT_ROWS }, (_, i) => (
    <div
      key={i}
      className={styles.skeletonRow}
    >
      <CustomSkeleton
        variant="rect"
        height={16}
        animation="wave"
        className={styles.skeletonName}
      />
      <CustomSkeleton
        variant="rect"
        width={90}
        height={16}
        animation="wave"
      />
      <CustomSkeleton
        variant="rect"
        width={30}
        height={16}
        animation="wave"
      />
    </div>
  ));
